import axios from 'axios'

import { Agent } from 'modules/Monitoring/types'

export const getAgents = async () => {
  return (await axios.get<Agent[]>('/agents')).data
}
